import { getAuthActions } from '@core-frontend/core-frontend';

import { deleteAllCookies } from '@/shared/lib/cookies';

export const logout = () => {
  const actions = getAuthActions();
  actions.logout();
  deleteAllCookies();
};
